var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCourseMetaBook = function SvgIconCourseMetaBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77029 27L2 31.5882C14.3429 30.8235 25.9143 37.7059 29 40",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40C23.5556 33.5385 12.6667 25.4615 1 25.4615L8 19.5",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40C26.7548 30.9643 14.2903 19.5714 5 18.7857L18.9355 7C20.5123 7.3601 21.9791 8.10439 23.209 9.16857",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 40C29.4 40 33.96 26.6957 18 16.5217L27.88 4C37 7.91304 37 21.2174 37 21.2174L29.4 40Z",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1L1 3V36L19 47L37 36V3L19 1Z",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconCourseMetaBook;